import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { LOAIYEUCAU } from '../constants';
import { Get, Post, Put, DeleteSingle } from '../../utils/httpProvider';
import { LOAIYEUCAU_API } from '../../utils/apiUrl';

// Lấy danh sách tất cả LoaiYeuCau
export const loaiYeuCauGetAllAction = createAsyncThunk(
    LOAIYEUCAU.GET_ALL,
    async () => {
        return Get(LOAIYEUCAU_API.GET_ALL)
            .then(response => response)
            .catch(error => error);
    }
);

// Lấy thông tin 1 LoaiYeuCau theo id
export const loaiYeuCauGetItemAction = createAsyncThunk(
    LOAIYEUCAU.GET_ITEM,
    async (id) => {
        return Get(LOAIYEUCAU_API.GET_ITEM(id))
            .then(response => response)
            .catch(error => error);
    }
);

// Thêm LoaiYeuCau mới
export const addLoaiYeuCauAction = createAsyncThunk(
    LOAIYEUCAU.ADD_LOAIYEUCAU,
    async (model) => {
        return Post(LOAIYEUCAU_API.ADD_ITEM, null, model, false)
            .then(response => response.status)
            .catch(error => error);
    }
);

// Sửa LoaiYeuCau
export const editLoaiYeuCauAction = createAsyncThunk(
    LOAIYEUCAU.EDIT_LOAIYEUCAU,
    async (model) => {
        return Put(LOAIYEUCAU_API.UPDATE_ITEM(model.id), null, model.data)
            .then(response => response.status)
            .catch(error => error);
    }
);

// Xóa LoaiYeuCau
export const deleteLoaiYeuCauAction = createAsyncThunk(
    LOAIYEUCAU.DELETE_LOAIYEUCAU,
    async (id, { rejectWithValue, fulfillWithValue }) => {
        return DeleteSingle(LOAIYEUCAU_API.DELETE_ITEM(id))
            .then(async response => {
                if (response.status === 200) return fulfillWithValue(response.status);
                return rejectWithValue(await response.json());
            })
            .catch(error => error);
    }
);

// State ban đầu
const initialState = {
    listLoaiYeuCau: [],
    loaiYeuCauItem: null
};

// Slice
export const loaiyeucauSlice = createSlice({
    name: LOAIYEUCAU.NAME_SLICE,
    initialState,
    reducers: {
        filterListLoaiYeuCau: (state, action) => {
            state.listLoaiYeuCau = state.listLoaiYeuCau.length > 0
                ? state.listLoaiYeuCau.filter(x => x.id !== action.payload)
                : [];
        }
    },
    extraReducers: (builder) => {
        builder
            // GetAll
            .addCase(loaiYeuCauGetAllAction.fulfilled, (state, action) => {
                state.listLoaiYeuCau = action.payload || [];
            })

            // GetItem
            .addCase(loaiYeuCauGetItemAction.fulfilled, (state, action) => {
                state.loaiYeuCauItem = action.payload;
            })
            .addCase(loaiYeuCauGetItemAction.rejected, (state) => {
                state.loaiYeuCauItem = null;
            });
    }
});

export const { filterListLoaiYeuCau } = loaiyeucauSlice.actions;

export default loaiyeucauSlice.reducer;